import { render, staticRenderFns } from "./SmartPointWidgetSelection.vue?vue&type=template&id=2b3b9482&scoped=true"
import script from "./SmartPointWidgetSelection.vue?vue&type=script&lang=js"
export * from "./SmartPointWidgetSelection.vue?vue&type=script&lang=js"
import style0 from "./SmartPointWidgetSelection.vue?vue&type=style&index=0&id=2b3b9482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3b9482",
  null
  
)

export default component.exports